import { BaseEntity } from 'yt-ng-framework';


export class VrstaStavki extends BaseEntity{
    constructor(){
        super();
    }
    
    Sifra: string=null;
    Naziv: string=null;
    RobaUsluga: string=null;
    Cena: number=0;
    JedinicaMereID: number=null;
    KontoID: number=null;
    TarifaID: number=null;
    Barkod: string = null;
   // OrgJedID: number = null;
    JezikID: number=1;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Sifra = input.Sifra;
        this.Naziv= input.Naziv;
        this.RobaUsluga=input.RobaUsluga;
        this.Cena=input.Cena;
        this.JedinicaMereID=input.JedinicaMereID;
        this.KontoID=input.KontoID;
        this.TarifaID=input.TarifaID;
        this.Barkod = input.Barkod;
        this.JezikID=input.JezikID;
       // this.OrgJedID=input.OrgJedID;
        return this;
    }

    Serialize(input: VrstaStavki){
        return input;
    }
}